import React, { useEffect, useMemo, useRef, useState, FC } from "react"
import { Form, Modal } from 'react-bootstrap'
import { useAsync, useQuery, formatPrice } from "../../utils"
import { getProductInAllPharmacy, getCountProductInAllPharmacy } from "../../api"
import { accountDataState } from "../../recoil/account";
import { useRecoilValue } from "recoil";
import { ProductInAllPharmacy } from "../../models";
import Loading from "../shared/Loading"
import { FormProduct } from "../Admin"
import ReactPaginate from 'react-paginate';



type IKeySort = "ASC" | "DESC"
type IFieldSort = "mPrice" | ""
type IPharmacyType = "" | "DEFAULT_PHARMACY"

interface IState {
    skip: number,
    limit: number,
    package: string,
    listProductInAllPharmacy: ProductInAllPharmacy[],
    total?: number,
    sort: {
        field: IFieldSort
        status: IKeySort
    },
    search: string,
    pharmacyType: IPharmacyType
}

const initState: IState = {
    skip: 0,
    limit: 20,
    package: "",
    listProductInAllPharmacy: [],
    total: 0,
    sort: {
        field: "mPrice",
        status: "ASC"
    },
    search: '',
    pharmacyType: "DEFAULT_PHARMACY"
}

interface IProps {
    product: any
}


const ProductPrice: FC<IProps> = React.memo((props) => {
    const { product } = props
    const query = useQuery();
    const tableProduct: any = useRef()

    const productId: string = query.get("productId") || "";
    const packageId: string = query.get("packageId") || "";
    const accountInfo = useRecoilValue(accountDataState);
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType == "ADMIN")
            return accountInfo.doctor.mId;
    }, [accountInfo]);
    const getProductInAllPharmacyAsync = useAsync(getProductInAllPharmacy)
    const getCountProductInAllPharmacyAsync = useAsync(getCountProductInAllPharmacy)

    const [state, setState] = useState<IState>(initState)
    const [selectedPharmacyId, setSelectedPharmacyId] = useState<string>("")
    const [mAdministrativeAreaLevel_0, setMAdministrativeAreaLevel_0] = useState("");
    const [pharmacyName, setPharmacyName] = useState("");
    const [listPackage, setListPackage] = useState<any>([{
        name: 'tất cả',
        mac_dinh: false,
    }]);
    const [showModal, setShowModal] = useState(false);
    const page: any = useRef()

    const backToTop = () => {
        if (!tableProduct.current?.scrollTop) return
        tableProduct.current.scrollTop = 0
    }

    useEffect(() => {
        if (!state.package) return;
        backToTop()
        const { field, status } = state.sort
        const order = `${field} ${status}`

        getProductInAllPharmacyAsync.execute(
            {
                adminId,
                filter: {
                    skip: initState.skip,
                    limit: state.limit,
                    order,
                    where: {
                        and: [
                            {
                                mProductId: productId
                            },
                            getQueryByDV(state.package),
                            getQueryByPharmacyType(state.pharmacyType),
                            {
                                mStatus: 'ACTIVE'
                            },
                            {
                                or: [
                                    {
                                        mProductStatus: {
                                            neq: 'REMOVED'
                                        }
                                    },
                                    {
                                        mProductStatus: {
                                            eq: null
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }
            }
        ).then(res => {
            setState(prev => ({
                ...prev,
                listProductInAllPharmacy: res.listProduct,
                skip: initState.skip,
            }))
        })

        getCountProductInAllPharmacyAsync.execute(
            {
                adminId,
                where: {
                    and: [
                        {
                            mProductId: productId
                        },
                        getQueryByDV(state.package),
                        getQueryByPharmacyType(state.pharmacyType),
                        {
                            mStatus: 'ACTIVE'
                        },
                        {
                            or: [
                                {
                                    mProductStatus: {
                                        neq: 'REMOVED'
                                    }
                                },
                                {
                                    mProductStatus: {
                                        eq: null
                                    }
                                }
                            ]
                        }
                    ]
                }
            }
        ).then(res => {
            setState(prev => ({
                ...prev,
                total: res.total
            }))
        })
    }, [state?.sort, state?.package, productId, adminId, state?.limit, state?.pharmacyType])

    useEffect(() => {
        if (!state.package) return;
        fetchListWithCurrentState();

    }, [state?.skip])

    const getQueryByDV = (dv: string) => {
        switch (dv) {
            case "tất cả":
            case "":
                return {}
            default:
                return {
                    mPkgName: dv
                }
        }
    }

    const getQueryByPharmacyType = (pharmacyType: IPharmacyType) => {
        switch (pharmacyType) {
            case "DEFAULT_PHARMACY":
                return {
                    mPharType: 'DEFAULT_PHARMACY'
                }
            default:
                return {}
        }
    }

    useEffect(() => {
        setShowModal(selectedPharmacyId ? true : false)
    }, [selectedPharmacyId])

    useEffect(() => {
        if (product && product.dong_goi) {
            product.dong_goi.map((item: any) => {
                setListPackage((prev: any) => ([
                    ...prev,
                    {
                        name: item.loai_dong_goi.name,
                        mac_dinh: item.mac_dinh
                    }
                ]))

                if (item.id == packageId) {
                    setState(prev => ({
                        ...prev,
                        package: item.loai_dong_goi.name
                    }))
                }
            })

        }
    }, [product])

    const fetchListWithCurrentState = async () => {
        backToTop()
        const { field, status } = state.sort
        const order = `${field} ${status}`

        getProductInAllPharmacyAsync.execute(
            {
                adminId,
                filter: {
                    skip: state.skip,
                    limit: state.limit,
                    order,
                    where: {
                        and: [
                            {
                                mProductId: productId
                            },
                            getQueryByDV(state.package),
                            getQueryByPharmacyType(state.pharmacyType),
                            {
                                mStatus: 'ACTIVE'
                            },
                            {
                                or: [
                                    {
                                        mProductStatus: {
                                            neq: 'REMOVED'
                                        }
                                    },
                                    {
                                        mProductStatus: {
                                            eq: null
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }
            }
        ).then(res => {
            setState(prev => ({
                ...prev,
                listProductInAllPharmacy: res.listProduct,
            }))
        })

        getCountProductInAllPharmacyAsync.execute(
            {
                adminId,
                where: {
                    and: [
                        {
                            mProductId: productId
                        },
                        getQueryByDV(state.package),
                        getQueryByPharmacyType(state.pharmacyType),
                        {
                            mStatus: 'ACTIVE'
                        },
                        {
                            or: [
                                {
                                    mProductStatus: {
                                        neq: 'REMOVED'
                                    }
                                },
                                {
                                    mProductStatus: {
                                        eq: null
                                    }
                                }
                            ]
                        }
                    ]
                }
            }
        ).then(res => {
            setState(prev => ({
                ...prev,
                total: res.total
            }))
        })
    }

    const handleCancelUpdate = () => {
        setSelectedPharmacyId("")
    }

    const handleUpdateSuccess = () => {
        fetchListWithCurrentState()
        setSelectedPharmacyId("")
    }

    const handleDeleteProduct = () => {
        fetchListWithCurrentState()
        setSelectedPharmacyId("")
    }

    const UpdateProductModal = () => {
        return (
            <Modal show={showModal}
                onHide={() => setSelectedPharmacyId("")}
                dialogClassName="product-update fullscreen"
            >
                <Modal.Body>
                    {
                        selectedPharmacyId ?
                            <FormProduct
                                productId={productId}
                                isModal={true}
                                handleCancelUpdate={handleCancelUpdate}
                                handleUpdateSuccess={handleUpdateSuccess}
                                handleDeleteProduct={handleDeleteProduct}
                                pharmacyId={parseInt(selectedPharmacyId)}
                                mAdministrativeAreaLevel_0={mAdministrativeAreaLevel_0}
                                pharmacyName={pharmacyName}
                            ></FormProduct>
                            : <></>
                    }

                </Modal.Body>
            </Modal>
        );
    }

    return <>
        <div id="main" style={{
            width: "100%",
            height: '100vh',
            minHeight: '-webkit-fill-available',
        }}
        >

            {getProductInAllPharmacyAsync.status == "loading" && <div className="wrap-loading">
                <Loading />
            </div>
            }
            <>
                <div className="container mt-4">
                    <UpdateProductModal></UpdateProductModal>

                    <div className="d-flex">
                        <div className="w-50 mx-2 d-flex align-items-center">
                            <Form.Label className='m-0 mr-1'><b>ĐV</b></Form.Label>
                            <Form.Control onChange={(e) => {
                                const value = e.target.value
                                setState(prev => ({ ...prev, package: value }))
                            }} name='filter' as="select" value={state.package} custom>
                                {listPackage.map((item: any, index: number) => {
                                    return <option key={index} value={item.name}>{item.name}</option>
                                })}
                            </Form.Control>
                        </div>
                        <div className="w-50 d-flex align-items-center mx-2">
                            <Form.Label className='m-0 mr-1'><b>SX</b></Form.Label>
                            <Form.Control onChange={(e) => {
                                const value = e.target.value as IKeySort
                                setState(prev => ({
                                    ...prev,
                                    sort: {
                                        field: 'mPrice',
                                        status: value
                                    }
                                }))
                            }
                            } name='sort' as="select" value={state.sort.status} custom>
                                <option value='ASC'>Tăng dần</option>
                                <option value='DESC'>Giảm dần</option>
                            </Form.Control>
                        </div>
                        <div className="w-50 d-flex align-items-center mx-2">
                            <Form.Label className='m-0 mr-1'><b>NT</b></Form.Label>
                            <Form.Control onChange={(e) => {
                                const value = e.target.value
                                setState(prev => ({ ...prev, pharmacyType: value as IPharmacyType }))
                            }} name='filter' as="select" value={state.pharmacyType} custom>
                                <option value=''>Tất cả</option>
                                <option value='DEFAULT_PHARMACY'>NTTT</option>
                            </Form.Control>
                        </div>
                    </div>
                </div>
                {
                    state.listProductInAllPharmacy.length === 0 &&
                    <div className="d-flex py-3 justify-content-center align-items-center">
                        <p className="m-0">Không tìm thấy sản phẩm nào</p>
                    </div>
                }
                <div className="row mt-2"></div>
                {
                    state.listProductInAllPharmacy.length > 0 &&
                    <>
                        <div ref={tableProduct} className="table-products" style={{ position: "relative", maxHeight: 'unset' }}>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Tên Nhà thuốc</th>
                                        <th style={{ width: 40 }}>ĐV</th>
                                        <th style={{ width: 80 }}>TT</th>
                                        <th style={{ width: 60 }}>ĐƠN GIÁ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        state.listProductInAllPharmacy?.map((product: ProductInAllPharmacy) => {
                                            return <tr key={product.mId} onClick={() => {
                                                setSelectedPharmacyId(product.mPharmacyId.toString())
                                                setMAdministrativeAreaLevel_0(product.mPharmacy?.mPharmacyAddress?.mAdministrativeAreaLevel0)
                                                setPharmacyName(product.mPharmacy?.mName)
                                            }}
                                            // className={product.mId == selectedInvItemId ? "table-active" : ""}
                                            >
                                                <td >{product.mPharmacy.mName}</td>
                                                <td style={{ width: 40 }}>{product.mPkgName}</td>
                                                <td style={{ width: 80 }}>
                                                    {
                                                        product.mInStock ?
                                                            <b style={{ borderRadius: 25, color: '#36cd7a', border: '1px solid #36cd7a', padding: '3px 4px' }}>Còn hàng</b> :
                                                            <b style={{ borderRadius: 25, color: '#F35353', border: '1px solid #F35353', padding: '3px 4px' }}>Hết hàng</b>
                                                    }
                                                </td>
                                                <td style={{ width: 60 }}>
                                                    {formatPrice(product.mPrice)} <br />
                                                </td>
                                            </tr>
                                        })
                                    }

                                </tbody>
                            </table>
                            {
                                getProductInAllPharmacyAsync.status == "error" &&
                                <div className="wrap-loading">
                                    <Loading />
                                </div>
                            }
                        </div>
                    </>
                }
            </>
            <div className="d-flex align-items-center justify-content-start my-3 px-3">
                <div className="pagination mt-3">
                    {
                        !!state.total &&
                        <ReactPaginate
                            pageClassName='page-item'
                            breakLabel="..."
                            onPageChange={(page: any) => {
                                console.log('page: ', page);
                                setState(prev => ({ ...prev, skip: state.limit * page.selected }))
                            }}
                            pageCount={Math.ceil(state.total / state.limit)}
                            pageRangeDisplayed={1}
                            marginPagesDisplayed={1}
                            previousLabel={<b className="pagination-navigator">{'<'}</b>}
                            nextLabel={<b className="pagination-navigator"> {'>'} </b>}
                            forcePage={(state.skip) / state.limit}
                        />
                    }
                </div>
                <Form.Control
                    className="select-page-limit"
                    onChange={(e) => {
                        const value = e.target.value
                        setState(prev => ({
                            ...prev,
                            limit: +value,
                        }))
                    }
                    }
                    name='limit'
                    as="select"
                    value={state.limit}
                    custom
                >
                    <option value='10'>10</option>
                    <option value='20'>20</option>
                    <option value='50'>50</option>
                    <option value='100'>100</option>
                </Form.Control>
            </div>
            <div className="d-flex align-items-center justify-content-end mb-4">
                <div className="d-flex align-items-center justify-content-end mr-3"
                    style={{ width: '60%' }}
                >
                    <b>Tổng số {state.total} sản phẩm</b>
                </div>
                <div className="d-flex align-items-center mr-3 justify-content-end"
                    style={{ width: '40%' }}>
                    <Form.Control type="number" className="mr-2" placeholder="Đến trang"
                        ref={page}
                        min={1}
                        style={{ width: '68%', height: '30px' }} />
                    <Form.Control
                        as="button"
                        onClick={() => {
                            if (page.current.value > 0 && state.total && page.current.value <= Math.ceil(state.total / state.limit)) {
                                setState(prev => ({ ...prev, skip: state.limit * (page.current.value - 1) }))
                            }
                        }}
                        style={{ width: '40px', height: '30px', color: '#fff', backgroundColor: '#36cd7a', border: 'none' }}
                    >Đi</Form.Control>
                </div>
            </div>
        </div>
    </>
}
)
export default ProductPrice;